import { AppsPanel } from './AppsPanel'
import { ArrowUpIcon, BoardIcon, BoxIcon, CheckIcon, ClapIcon, ImageIcon, PlusIcon, SlidersIcon, WandIcon, WaveIcon, WrenchIcon } from '../ProductFrameIcons'

const CALLS = [
  { name: 'Inspect canvas', done: true },
  { name: 'Generate images', done: true },
  { name: 'Check outputs', done: false },
] as const

/** Linear: the conversation with the agent, results with their next moves, the composer, and Apps beside it. */
export function ChatView() {
  return (
    <div className="absolute inset-0 bg-ground">
      <AppsPanel />
      <div className="absolute inset-y-0 left-0 right-[266px] flex justify-center">
        <div className="flex h-full w-[600px] flex-col pt-5 pb-3">
          <div className="ml-auto max-w-[360px] rounded-xl bg-panel px-3.5 py-2.5 text-[12px] leading-relaxed">
            Make the poster grittier. Relight it, rougher paper, and give me options I can keep editing.
          </div>
          <p className="mt-4 text-[12px] leading-relaxed text-muted">
            Reading poster-04, then Z-Image Turbo passes on your GPU. They land on the artboard as they finish.
          </p>
          <ul className="mt-2 flex flex-col gap-1">
            {CALLS.map((c) => (
              <li key={c.name} className="flex items-center gap-2 text-[11px] text-muted">
                <WrenchIcon width={10} height={10} />
                {c.name}
                {c.done ? (
                  <CheckIcon width={10} height={10} className="text-[#2f9e62]" />
                ) : (
                  <span className="ping size-1.5 rounded-full bg-lamp" />
                )}
              </li>
            ))}
          </ul>
          <div className="mt-3 flex min-h-0 flex-1 gap-2">
            <img src="/images/medium-photography.jpg" alt="" className="h-full min-h-0 w-[230px] rounded-lg object-cover" />
            <img src="/images/medium-fashion.jpg" alt="" className="h-full min-h-0 w-[180px] rounded-lg object-cover" />
            <div className="flex h-full w-[180px] flex-col justify-end gap-1.5 rounded-lg bg-panel p-3 ring-1 ring-lamp">
              <span className="num text-[10px] text-muted">62%</span>
              <span className="block h-[2px] w-full bg-line">
                <span className="block h-full w-[62%] bg-lamp" />
              </span>
            </div>
          </div>
          <div className="mt-2 flex gap-1.5 text-[11px]">
            <span className="rounded-md border border-line px-2.5 py-1">Use as reference</span>
            <span className="flex items-center gap-1.5 px-2 py-1 text-muted">
              <SlidersIcon width={11} height={11} /> Open in app
            </span>
            <span className="flex items-center gap-1.5 px-2 py-1 text-muted">
              <BoardIcon width={11} height={11} /> Artboard
            </span>
          </div>
          <div className="mt-3 rounded-2xl border border-line bg-card p-3 shadow-[0_2px_8px_rgba(0,0,0,0.04)]">
            <p className="text-[12px] text-faint">Describe what you want to make…</p>
            <div className="mt-4 flex items-center gap-1 text-muted">
              <span className="flex size-6 items-center justify-center rounded-md bg-panel text-bone">
                <WandIcon width={12} height={12} />
              </span>
              {[ImageIcon, ClapIcon, WaveIcon, BoxIcon, PlusIcon].map((Icon, i) => (
                <span key={i} className="flex size-6 items-center justify-center">
                  <Icon width={12} height={12} />
                </span>
              ))}
              <span className="ml-auto flex size-6 items-center justify-center rounded-full bg-bone text-card">
                <ArrowUpIcon width={12} height={12} />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
